import transformations from "../../data/transformations";
import TransformationCard from "../common/TransformationCard";
import SectionHeading from "../common/SectionHeading";
import "./TransformationSection.css";

export default function TransformationSection() {
  return (
    <section className="transformation-section section">
      <div className="container">
        <SectionHeading
          eyebrow="Real Progress"
          title="Drag the slider,"
          highlight="see the change"
          description="A look at what consistent, coached training can do. Drag to compare — individual results may vary."
        />
        <div className="transformation-section__grid">
          {transformations.map((t) => (
            <TransformationCard transformation={t} key={t.id} />
          ))}
        </div>
      </div>
    </section>
  );
}
